import { localget } from 'Utils/storage.js'
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters(['userInfo'])
  },
  filters: {
    icon (val) {

      let iconsEnum = {
        '10901,11001,11002,11003,10902,11004,11005,11006': 'iconweibiaoti-1',//icon_tk,
        '10903,11007,11008': 'iconweibiaoti-13',//icon_ht,
        '10904,11009,11010,11011': 'iconweibiaoti-12',//icon_tr,
        '10906,11018': 'iconweibiaoti-11',
        '10913,11023': 'iconweibiaoti-141',
        '10914,11028': 'iconweibiaoti-138',
        '10915,11029': 'iconweibiaoti-139',
        '10916,11030': 'iconweibiaoti-140',
        '10917,11031': 'iconweibiaoti-137'
      }
      for (const type in iconsEnum) {
        if (type.indexOf(val) > -1) return iconsEnum[type]
      }

      return ''
    },
    color(val){
      let obj = {
        11001: '#dbab56',//icon_tk,
        11002: '#dbab56',//icon_tk,
        11003: '#dbab56',//icon_tk,
        11004: '#dbab56',//icon_tk,
        11005: '#dbab56',//icon_tk,
        11006: '#dbab56',//icon_tk,
        11007: '#ffb757',//icon_ht,
        11008: '#ffb757',//icon_ht,
        11009: '#6452ef',//icon_tr,
        11010: '#6452ef',//icon_tr,
        11011: '#6452ef',//icon_tr,
        11018: '#51a5f2',//icon_car,
        11023: '#ed7f4f',//icon_visa,
        11028: '#f7bc33',
        11029: '#a1d656',
        11030: '#3ed9e5',
        11031: '#4e95ea',
      }
      return obj[val]||''
    },
    apprpvalIcon (val) {
      let iconsEnum = {
        '11001,11004': 'iconweibiaoti-19',//icon_tk,
        '11002,11005': 'iconweibiaoti-113',//icon_tk,
        '11003,11006': 'iconweibiaoti-114',//icon_tk,
        '11007': 'iconweibiaoti-119',//icon_ht,
        '11008': 'iconweibiaoti-118',//icon_ht,
        '11009': 'iconweibiaoti-115',//icon_tr,
        '11010': 'iconweibiaoti-117',//icon_tr,
        '11011': 'iconweibiaoti-116',//icon_tr,
        '11099': 'iconweibiaoti-112',
        '11023': 'iconweibiaoti-144',
      }
      for (const type in iconsEnum) {
        if (type.indexOf(val) > -1) return iconsEnum[type]
      }

      return ''
    },
    //机票：0特价 1普通 2官网电商 3协议 7GP
    //酒店：1现付担保
    //用车：1日包 2半日包 3点到点 4接机 5送机 6接站 7送站  8即时快车 9预约快车 10及时专车 11预约专车 12及时出租车 13预约出租车
    productType(type) {
      var obj = { '0': '特价', '1': '', '2': '电商', '3': '协议', '6': '', '7': 'GP' }
      return obj[type]||''
    },
    productTypeColor(type) {
      var obj = { '0': '#f24812', '1': '', '2': '#90b7fc', '3': '#fd9437', '6': '', '7': '#ed6a0c' }
      return obj[type]||''
    },
    carproductType(type) {
      var obj = {
        '0': '',
        '1': '日包',
        '2': '半日包',
        '3': '3点到点',
        '4': '接机',
        '5': '送机',
        '6': '接站',
        '7': '送站',
        '8': '即时快车',
        '9': '预约快车',
        '10': '及时专车',
        '11': '预约专车',
        '12': '及时出租车',
        '13': '预约出租车'
      }
      return obj[type] || ''
    },
    setOutModel(type){
      var obj={'0':'国内出发/国际出发','1':'国内出发','2':'国内到达','3':'国际出发','4':'国际到达'}
      return obj[type]||''
    },
    orderType(type){
      var obj={
        11028:'休息室',
        11029:'快速安检',
        11030:'优先值机',
        11031:'要客通',
      }
      return obj[type]||''
    }
  }
}

